import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth';
import {
  developerHomeRedirectGuard,
  developerPortalGuard,
  permissionGuard,
} from '@core/guards/permission';
import { ROUTE_ACCESS } from '@core/constants/route-access.constants';
import { PROJECT_360_API_MODE } from '@features/real-estate/constants/project-360-api-mode.constants';

// Sign-in and registration live in Brooch Identity — `authGuard` sends anonymous
// visitors there with a login intent, so this app has no auth pages of its own.
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layout/main-layout/main-layout').then(m => m.MainLayout),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        canActivate: [developerHomeRedirectGuard],
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then(m => m.dashboardRoutes),
      },
      {
        path: 'sales',
        loadChildren: () => import('./features/sales/sales.routes').then(m => m.salesRoutes),
      },
      {
        path: 'marketing',
        loadChildren: () =>
          import('./features/marketing/marketing.routes').then(m => m.marketingRoutes),
      },
      {
        path: 'tasks',
        canActivate: [permissionGuard(ROUTE_ACCESS.tasks)],
        loadChildren: () => import('./features/tasks/tasks.routes').then(m => m.tasksRoutes),
      },
      {
        path: 'commissions',
        canActivate: [permissionGuard(ROUTE_ACCESS.commissions)],
        loadChildren: () =>
          import('./features/commissions/commissions.routes').then(m => m.commissionsRoutes),
      },
      {
        path: 'real-estate',
        loadChildren: () =>
          import('./features/real-estate/real-estate.routes').then(m => m.realEstateRoutes),
      },
      {
        path: 'lead-management',
        loadChildren: () =>
          import('@features/lead-management/lead-management.routes').then(
            m => m.leadManagementRoutes
          ),
      },
      {
        path: 'customer-experience',
        loadChildren: () =>
          import('./features/customer-experience/customer-experience.routes').then(
            m => m.customerExperienceRoutes
          ),
      },
      {
        path: 'developer',
        canActivate: [developerPortalGuard],
        children: [
          {
            path: 'projects/:id/full-project-details',
            title: 'pages.fullProjectDetails.title',
            // Project 360 reads the developer portal's `/full/*` API here.
            providers: [{ provide: PROJECT_360_API_MODE, useValue: 'portal' }],
            loadComponent: () =>
              import('@features/real-estate/pages/project-full-details/project-full-details').then(
                m => m.ProjectFullDetails
              ),
          },
          {
            path: '',
            loadChildren: () =>
              import('./features/developer-portal/developer-portal.routes').then(
                m => m.developerPortalRoutes
              ),
          },
        ],
      },
      {
        path: 'unauthorized',
        title: 'unauthorized.title',
        loadComponent: () =>
          import('@shared/pages/unauthorized/unauthorized').then(m => m.Unauthorized),
      },
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        // Last: a URL no route above matches.
        path: '**',
        title: 'notFound.pageTitle',
        loadComponent: () => import('@shared/pages/not-found/not-found').then(m => m.NotFound),
      },
    ],
  },
];
